import React, { useEffect, useState } from "react";
import api from "../api/api"
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../context/AuthContext";
import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
const BookEmployerBiodataShared = ({ biodata, isAccepted, fetchData, isOpen }) => {

    const { t } = useTranslation();
    const {user} = useAuth();
    const schema = yup.object({
        employer_id: user.type === "agency" && isAccepted == undefined ? yup
        .number("Employer is required")
        .required("Employer is required")
        : yup.mixed().notRequired(),
        notes: yup.string().notRequired(),
    });

    const {
      reset,
      handleSubmit,
      control,
      register,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });

    const [employers, setEmployers] = useState([]);
     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [message,setmessage] = useState(null)
     const location = useLocation();

    const token = new URLSearchParams(location.search).get("token");

    let text = {};
    if (isAccepted) {
        text = {
            title: t("Book Biodata"),
            message: t("Are you sure you want to accept this book?"),
        };
    } else if (isAccepted == false) {
        text = {
            title: t("Book Biodata"),
            message: t("Are you sure you want to decline this book?"),
        };
    } else {
        text = {
            title: t("Book Biodata"),
            message: t("Are you sure you want to book this biodata?"),
        };
    }

    
    const fetchDataEmployers = async () => {
        if (user.type !== "agency") return; // Only fetch if user is an agency
        try {
            const response = await api.get("/get-employer");
            setEmployers(response.data.employers);
        } catch (error) {
            let errorMessage = "";
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                Object.entries(error.response.data).forEach(([key, values]) => {
                    console.log(key, values);
                    errorMessage += `${values}\n`;
                }
                );
            }
        }
    }

     
    const onSubmit = async(data) => {
        clearErrors();
        setmessage(null)
        let typeurl = "/employer-biodata-shared-book/";
        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        try {  
            data = {
                ...data,
                booking_id: biodata.booking_id,
                biodata_id: biodata.id,
                // employer_id: biodata.employer_id,
                is_supplier_biodata: (biodata.supplier ?? biodata.biodata_supplier_id )? true : false,
                user_type: user.type,
                user_id: user.id,
                is_accepted: isAccepted,
                token: token,
            }
            const response = await api.post(typeurl, data); 
            reset({schedule: "", notes: ""});
            setmessage(response.data.message)
            fetchData()

            // Close the modal after successful submission
            const modalElement = document.getElementById("book_biodata_dialog");
            if (modalElement) {
                const buttonClose = modalElement.querySelector(".btn-close");
                if (buttonClose) {
                    buttonClose.click();
                }
            }
            
               
            

        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "agency") {
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }

    useEffect(() => {
        if (!isOpen) return;
        fetchDataEmployers();
    }, [isOpen]);
    
    useEffect(() => {
        const modalElement = document.getElementById("book_biodata_dialog");
    
        const handleModalShow = () => {
          setmessage(null); // Reset message when modal is opened
          clearErrors(); // Clear any existing errors
        };
    
        if (modalElement) {
          modalElement.addEventListener("show.bs.modal", handleModalShow);
        }
    
        return () => {
          if (modalElement) {
            modalElement.removeEventListener("show.bs.modal", handleModalShow);
          }
        };
      }, []);

    return (
        <div className="modal custom-modal modal-lg fade" id="book_biodata_dialog" role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{text.title}</h4>
                            <p className="mb-0">{text.message}</p>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    {
                                         user.type === "agency" && isAccepted == undefined && (
                                            <>
                                            <div className="input-block mt-2">
                                                <label>{t("Employer")}</label>
                                                <Controller 
                                                    name="employer_id"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Select
                                                        options={employers.map((employer) => ({
                                                            value: employer.id,
                                                            label: employer.name
                                                        }))}
                                                        placeholder={t("Select Employer")}
                                                        isClearable
                                                        value={employers
                                                            .map((employer) => ({
                                                            value: employer.id,
                                                            label: employer.name
                                                            }))
                                                            .find(option => option.value === field.value)}
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption ? selectedOption.value : "");
                                                        }}
                                                        />
                                                    )}
                                                />
                                                <small className="text-danger">{t(errors?.employer_id?.message)}</small>
                                            </div>
                                           </>
                                        )
                                    }
                                    
                                    {
                                        isAccepted !== undefined ? (
                                           <>
                                                <div className="input-block mb-3">
                                                    <label>Notes</label>
                                                    <textarea
                                                        {...register("notes")}
                                                        className="form-control"
                                                        placeholder="Enter Notes"
                                                    ></textarea>
                                                    <small>{errors?.notes?.message}</small>
                                                </div>
                                           </>
                                        ) : (
                                            <div className="input-block mb-3">

                                            </div>
                                        )
                                    }
                                    
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        <small  style={{color:"green"}}> {message && <p>{message}</p>}</small>
                        <small  style={{color:"red"}}> {errors.root && <p>{t(errors.root.message)}</p>}</small>
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
                            <button type="submit"  className="btn btn-primary " 
                            disabled={loadingSendInv} 
                            >{t("Submit")}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            </button>
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
BookEmployerBiodataShared.propTypes = {
    biodata: PropTypes.object.isRequired,
    isAccepted: PropTypes.bool,
    fetchData: PropTypes.func,
    isOpen: PropTypes.bool,
  };
export default BookEmployerBiodataShared;
